<template>
    <div id="ag-grid-demo">
        <vx-card>
            <!-- Filter Merchant -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Merchant</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <v-select multiple :closeOnSelect="false" v-model="selected" :options="merchant_list"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="change" />
                </div>
            </div>

            <!-- filter device -->

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Device</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <v-select id="cbo-device" v-model="filter_device" placeholder="Select device" :options="device_list"
                        @input="changeDevice">
                    </v-select>
                </div>
            </div>

            <!-- Filter date -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Date</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    <flat-pickr id="dtp-transaction-summary-datebegin" :config="configFromdatePicker"
                        v-model="filter.date_begin" placeholder="Date begin" @on-change="onFromChange"
                        @on-close="resetFilter" />
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    <flat-pickr id="dtp-transaction-summary-dateend" :config="configTodatePicker"
                        v-model="filter.date_end" placeholder="Date end" @on-change="onToChange"
                        @on-close="resetFilter" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Transaction Status</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <v-select id="cbo-device" v-model="filterStatus" placeholder="Select status" :options="statusList"
                        @input="changeStatus">
                    </v-select>

                </div>
            </div>

            <!-- Button -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>&nbsp;</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-button id="btn-filter" icon-pack="feather" icon="icon-search" v-on:click="fetchData(1, limit)"
                        class="mr-3 mb-2 float-left">Filter</vs-button>
                    <vs-button icon-pack="feather" icon="icon-refresh-cw" color="warning" v-on:click="resetSearch()"
                        class="mr-3 mb-2 float-left">Reset</vs-button>
                    <vs-button type="gradient" color="success" id="btn-download-xlsx" icon-pack="feather"
                        icon="icon-download" v-on:click="downloadXLSX()" class="mr-3 mb-2 float-left">Download xlsx
                    </vs-button>
                    <vs-button color="dark" id="btn-refresh" icon-pack="feather" icon="icon-target"
                        v-on:click="fetchData(1, limit)" class="mr-3 mb-2 float-left">Refresh</vs-button>
                </div>
            </div>



        </vx-card>

        <div class="vx-row h-100">
            <div class="vx-col md:w-4/4 w-full mb-base">
                <vs-alert active="true" icon="info">
                    Notes: Halaman ini akan refresh otomatis setiap {{ refreshTime }}
                </vs-alert>
            </div>
        </div>
        <vx-card>
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">
                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage *
                                limit > 0 ? currentPage * limit : dataCount
                            }} of {{ dataCount }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu id="ddl-page-limit">
                            <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-3" @click="fetchData(1, 100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-4" @click="fetchData(1, 150)">
                                <span>150</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->

            </div>
            <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="dataTrx" rowSelection="multiple"
                colResizeDefault="shift" :animateRows="true" :floatingFilter="true" :pagination="true"
                :paginationPageSize="limit" :suppressPaginationPanel="true" :enableCellTextSelection="true">
            </ag-grid-vue>
            <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPageTable" />
        </vx-card>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { url } from "@/configs/apiUrl";
import Axios from "@/global/AxiosCall";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import ActionDetailGridComponent from "../../../components/cell-render-component/device-transaction-summary/ActionDetailGridComponent";
import vSelect from 'vue-select'
import moment from 'moment'
import VueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
    name: "DeviceTransactionSummary",
    components: {
        flatPickr,
        AgGridVue,
        VueSimpleSuggest,
        'v-select': vSelect,
    },
    data() {
        return {
            refreshTime: 0,
            filterStatus: '',
            statusList: [
                { id: 0, label: 'ALL' },
                { id: 1, label: "OK" },
                { id: 2, label: "CHECK" },
            ],
            chosen: '',
            selected: [],
            model: null,
            mode: 'input',
            loading: false,
            log: [],
            urlx: null,
            interval: null,
            retrievingUserInfo: true,
            showMerchantFilter: true,
            userInfo: {
                group: "root"
            },
            dateformat: "yyyy-MM-dd",
            configFromdatePicker: {
                minDate: null,
                maxDate: null,
                dateFormat: 'Y-m-d',
            },
            configTodatePicker: {
                minDate: null,
                dateFormat: 'Y-m-d',
            },
            filterDevice: 'All Device',
            searchQuery: "",
            gridOptions: {},
            maxPageNumbers: 10,
            currentPage: 1,
            currentPageTable: 1,
            gridApi: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true,
            },
            columnDefs: [
                {
                    headerName: "#",
                    field: "no",
                    width: 80
                },
                {
                    headerName: "Merchant",
                    field: "merchant",
                    filter: true,
                },
                {
                    headerName: "Merchant Code",
                    field: "merchant_code",
                    filter: true,
                    width: 170
                },
                {
                    headerName: "Device Name",
                    field: "device_name",
                    filter: true,
                },
                {
                    headerName: "Device Code",
                    field: "device_code",
                    filter: true,
                },
                {
                    headerName: "Status",
                    field: "status",
                    filter: true,
                    width: 170,
                    cellRenderer: this.nullColumnRenderer
                },
                {
                    headerName: "Date",
                    field: "date",
                    width: 225
                },
                {
                    headerName: "Final Status",
                    field: "final_status",
                    filter: false,
                    width: 150,
                    cellRenderer: this.nullColumnRenderer,
                    cellStyle: { textAlign: "center" }
                },
                {
                    headerName: "Tap In",
                    field: "tap_in",
                    filter: false,
                    width: 100,
                    cellRenderer: this.nullColumnRenderer,
                    cellStyle: { textAlign: "center" }
                },
                {
                    headerName: "Invalid",
                    field: "invalid",
                    filter: false,
                    width: 100,
                    cellRenderer: this.nullColumnRenderer,
                    cellStyle: { textAlign: "center" }
                },
                {
                    headerName: "Valid",
                    field: "valid",
                    filter: false,
                    width: 150,
                    cellRenderer: this.nullColumnRenderer,
                    cellStyle: { textAlign: "center" }
                },
                {
                    headerName: "In Chipbased",
                    field: "total_chipbased",
                    filter: false,
                    width: 150,
                    cellRenderer: this.nullColumnRenderer,
                    cellStyle: { textAlign: "center" }
                },
                {
                    headerName: "In Device",
                    field: "total_in_device",
                    filter: false,
                    width: 120,
                    cellRenderer: this.nullColumnRenderer,
                    cellStyle: { textAlign: "center" }
                },
                {
                    headerName: "In Server",
                    field: "num_raw_trxn",
                    width: 120,
                    filter: false,
                    cellRenderer: this.nullColumnRenderer,
                    cellStyle: { textAlign: "center" }
                },
                {
                    headerName: "Last Sent Device Transaction",
                    field: "update_timestamp",
                    width: 290
                },
                {
                    headerName: "Actions",
                    field: "action",
                    filter: false,
                    width: 140,
                    cellRendererFramework: ActionDetailGridComponent
                },
            ],
            dataTrx: [],
            merchantSub: [],
            dataCount: 0,
            totalPage: 0,
            page: 1,
            limit: 20,
            totalData: 1,
            merchant_list: [],
            merchants: {},
            merchants_data_is_ready: false,
            device_list: [],
            filter_device: [],
            filter: {
                device: "",
                merchant: null,
                date_begin: "",
                date_end: ""
            }
        };
    },
    created: function () {
        this.refreshTime = this.secToTime(process.env.VUE_APP_INTERVAL_DEVICE_TIME)
        const time_interval = process.env.VUE_APP_INTERVAL_DEVICE_TIME * 1000 == 0 ? 600000 : process.env.VUE_APP_INTERVAL_DEVICE_TIME * 1000;
        this.interval = setInterval(function () {
            this.fetchData(this.page, this.limit);
        }.bind(this), time_interval);
    },
    watch: {
        "$store.state.windowWidth"(val) {
            if (val <= 576) {
                this.maxPageNumbers = 5;
                this.gridOptions.columnApi.setColumnPinned("Channel", null);
            } else this.gridOptions.columnApi.setColumnPinned("Channel", "left");
        },
        selected() {
            this.resetFilter()
        },
        currentPageTable: function (val) {
            this.page = val;
            if (val > 1) {
                this.fetchData(val, this.limit)
            } else {
                this.fetchData(val, this.limit)
            }
        },

    },
    computed: {
    },
    methods: {
        secToTime(sec) {
            let minutes = (sec / 60);
            let hours = (sec / (60 * 60));
            let days = (sec / (60 * 60 * 24));
            if (sec < 60) return sec + " detik";
            else if (minutes < 60) return minutes + " menit";
            else if (hours < 24) return hours + " jam";
            else return days + " hari"
        },
        onFromChange(selectedDates, dateStr) {
            this.$set(this.configTodatePicker, 'minDate', dateStr);
        },
        onToChange(selectedDates, dateStr) {
            this.$set(this.configFromdatePicker, 'maxDate', dateStr);
        },
        isShowMerchantFilter() {
            return ((this.userInfo.group == 'issuer') ? false : true)
        },
        nullColumnRenderer(params) {
            if (params.value === null)
                return '-'
            else
                return params.value
        },
        change(val) {
            for (let data of val) {
                if (data.code === "") {
                    this.selected = []
                    this.selected.push({ full_name: "All Merchant", code: "", label: "All Merchant" })
                    break
                }
            }
        },
        changeStatus(value) {
            if (!value) {
                this.filterStatus = [{ id: 0, label: 'ALL' }];
            }
        },
        changeDevice(value) {
            if (!value) {
                this.filter_device = [{
                    label: "Select All",
                    name: "Select All",
                    text: "Select All",
                    code: "select_all"
                }];
            }
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val);
        },
        resetSearch() {
            this.selected = []
            this.filter.date_begin = moment().format("YYYY-MM-DD")
            this.filter.date_end = moment().format("YYYY-MM-DD")
            this.filter_device = [{
                label: "Select All",
                name: "Select All",
                text: "Select All",
                code: "select_all"
            }]
            this.filterStatus = [{ id: 0, label: 'ALL' }]
        },
        downloadXLSX() {

            let APIURL = ""

            APIURL = url.device_trxn_summary.list + "?page=1&limit=9223372036854775807"
            let merchant_code = ""

            let merchant_jaklingko = this.selected.filter(data => data.depth == "1" || data.full_name == "All Merchant")

            let merchant_pto = this.selected.filter(data => data.depth == "2").map(data => data.code)

            let sub_merchant_pto = this.selected.filter(data => data.depth == "3").map(data => data.code)

            if (this.selected.length > 0) {
                if (this.selected[0].code === "" || merchant_jaklingko.length !== 0) {
                    for (let data of this.merchant_list) {
                        if (data.code !== "") merchant_code += data.code + ","
                    }
                    this.fetchDownloadXLSX(APIURL, merchant_code)

                } else if (merchant_pto !== 0) {
                    let payload = {
                        merchant_code: merchant_pto,
                    }
                    Axios.Post(url.svd.merchant.comboSubMerchant, payload).then(resp => {
                        if (resp.code === 200) {
                            for (let data of resp.data) {
                                if (data.code !== "") merchant_code += data.code + ","
                            }
                            if (sub_merchant_pto !== 0) {
                                for (let dataSubMerchant of sub_merchant_pto) {
                                    merchant_code += dataSubMerchant + ","
                                }
                            }
                            this.fetchDownloadXLSX(APIURL, merchant_code)
                        }
                    })
                } else {
                    for (let data of this.selected) {
                        if (data.code !== "") merchant_code += data.code + ","
                    }
                    this.fetchDownloadXLSX(APIURL, merchant_code)
                }
            } else {
                for (let data of this.merchant_list) {
                    if (data.code !== "") merchant_code += data.code + ","
                }
                this.fetchDownloadXLSX(APIURL, merchant_code)
            }

        },

        fetchDownloadXLSX(APIURL, merchant_code) {

            merchant_code = merchant_code.replace(/,\s*$/, "")
            APIURL += "&merchantcode=" + merchant_code
            APIURL += (this.filter.date_begin !== "") ? "&date_begin=" + this.filter.date_begin : ""
            APIURL += (this.filter.date_end !== "") ? "&date_end=" + this.filter.date_end : ""

            if (this.filterStatus.label !== 'ALL' && this.filterStatus.label != undefined) {
                APIURL += "&status=" + this.filterStatus.label;
            }

            if (this.filter_device.device_code != undefined) {
                APIURL += "&devicecode=" + this.filter_device.device_code
            }

            APIURL += "&download_xlsx=true"

            Axios.DownloadFile({ path: APIURL, method: 'GET' }, { name: "device_transaction_summary_" + this.filter.date_begin + "_" + this.filter.date_end + ".zip" })

        },
        fetchData(page, limit) {

            let newPage = page
            if (this.dataTrx.length === 0) {
                newPage = 1
            }
            if (limit < 20) {
                limit = 20
            }
            let APIURL = ""

            APIURL = url.device_trxn_summary.list + "?page=" + newPage + "&limit=" + limit
            let merchant_code = ""


            let merchant_jaklingko = this.selected.filter(data => data.depth == "1" || data.full_name == "All Merchant")

            let merchant_pto = this.selected.filter(data => data.depth == "2").map(data => data.code)

            let sub_merchant_pto = this.selected.filter(data => data.depth == "3").map(data => data.code)

            if (this.selected.length > 0) {
                if (this.selected[0].code === "" || merchant_jaklingko.length !== 0) {
                    for (let data of this.merchant_list) {
                        if (data.code !== "") merchant_code += data.code + ","
                    }
                    this.processFetchData(APIURL, merchant_code, limit, page)
                } else if (merchant_pto !== 0) {
                    let payload = {
                        merchant_code: merchant_pto,
                    }
                    Axios.Post(url.svd.merchant.comboSubMerchant, payload).then(resp => {
                        if (resp.code === 200) {
                            for (let data of resp.data) {
                                if (data.code !== "") merchant_code += data.code + ","
                            }
                            if (sub_merchant_pto !== 0) {
                                for (let dataSubMerchant of sub_merchant_pto) {
                                    merchant_code += dataSubMerchant + ","
                                }
                            }
                            this.processFetchData(APIURL, merchant_code, limit, page)
                        } else {
                            this.$vs.loading.close()
                            this.dataCount = 0
                            this.totalPage = 0
                            this.dataTrx = []
                            this.maxPageNumbers = 10
                        }
                    }).catch(e => {
                        console.log(e);
                        this.$vs.loading.close()
                        this.dataCount = 0
                        this.totalPage = 0
                        this.dataTrx = []
                        this.maxPageNumbers = 10
                    });
                } else {
                    for (let data of this.selected) {
                        if (data.code !== "") merchant_code += data.code + ","
                    }
                    this.processFetchData(APIURL, merchant_code, limit, page)
                }
            } else {
                for (let data of this.merchant_list) {
                    if (data.code !== "") merchant_code += data.code + ","
                }
                this.processFetchData(APIURL, merchant_code, limit, page)
            }

        },
        processFetchData(APIURL, merchant_code, limit, page) {
            merchant_code = merchant_code.replace(/,\s*$/, "")
            APIURL += "&merchantcode=" + merchant_code

            APIURL += (this.filter.date_begin !== "") ? "&date_begin=" + this.filter.date_begin : ""
            APIURL += (this.filter.date_end !== "") ? "&date_end=" + this.filter.date_end : ""


            if (this.filterStatus.label !== 'ALL' && this.filterStatus.label != undefined) {
                APIURL += "&status=" + this.filterStatus.label;
            }

            if (this.filter_device.device_code != undefined) {
                APIURL += "&devicecode=" + this.filter_device.device_code
            }
            this.openLoading()
            Axios.Get(APIURL)
                .then(resp => {
                    this.$vs.loading.close()
                    this.dataTrx = [];
                    this.dataCount = 0
                    this.totalPage = 0
                    if (resp.data.data.length > 0) {
                        this.totalData = parseInt(resp.data.total)
                        let no = 1 + ((resp.data.page - 1) * resp.data.perPage)
                        for (let data of resp.data.data) {
                            data.no = no;
                            data["num_sum_trxn"] = data.num_summary_trxn_failed + data.num_summary_trxn_success
                            let status = data.status
                            // let classel = (data.status === "WARNING" ? "text-danger": ((data.status === "CHECK")? "text-warning": "text-success")
                            let classel = ""
                            switch (data.status) {
                                // case "NO_SUMMARY":
                                //     classel="text-primary"
                                // break;
                                // case "WARNING":
                                //      classel = "text-danger"
                                // break;
                                case "CHECK":
                                    classel = "text-warning"
                                    break;
                                case "OK":
                                    classel = "text-success"
                                    break;
                                default:
                                    classel = "text-warning"
                            }
                            data["update_timestamp"] = data.update_timestamp
                            data["status"] = "<span class='" + classel + "'>" + data["status"] + "</span>"
                            data["merchant"] = (typeof this.merchants[data.merchant_code] !== 'undefined') ? this.merchants[data.merchant_code] : "UNKNOWN MERCHANT"
                            data["action"] = data.device_code + "|||" + data["date"] + "|||" + data["summary_data_available"] + "|||" + data["num_summary_trxn_success"] + "|||" + data["num_summary_trxn_failed"] + "|||" + data["merchant"] + "|||" + status + "|||" + data.update_timestamp + "|||" + data.merchant_code
                            this.dataTrx.push(data);
                            no++;
                        }

                        this.dataCount = resp.data.total
                        this.page = page;
                        if (limit >= this.dataCount) {
                            this.limit = this.dataTrx.length;
                        } else {
                            this.limit = limit;
                        }


                        this.gridApi.paginationSetPageSize(this.limit);
                        this.totalPage = Math.ceil(this.dataCount / this.limit);

                        if (resp.data.lastPage == 1 || resp.data.lastPage == 2 || resp.data.lastPage == 3) {
                            this.maxPageNumbers = 5
                        } else if (resp.data.lastPage == 4 || resp.data.lastPage == 5 || resp.data.lastPage == 6) {
                            this.maxPageNumbers = 7
                        } else if (resp.data.lastPage == 7 || resp.data.lastPage == 8) {
                            this.maxPageNumbers = 8
                        } else {
                            this.maxPageNumbers = 10
                        }

                        if (resp.data.lastPage > 0) {
                            this.currentPageTable = resp.data.page
                        } else {
                            this.currentPageTable = 1
                        }

                        if (this.currentPageTable > resp.data.lastPage) {
                            this.currentPageTable = 1
                        }

                    } else {
                        this.limit = 20
                        this.dataCount = 0
                        this.totalPage = 0
                    }
                })
                .catch(e => {
                    console.log(e);
                    this.$vs.loading.close()
                    this.dataCount = 0
                    this.totalPage = 0
                    this.dataTrx = []
                    this.maxPageNumbers = 10
                });
        },
        openLoading() {
            this.$vs.loading({
                type: "default"
            });
        },
        detailRecord(data) {
            let paramstring = data.split("|||")
            if (paramstring.length > 1) {

                for (let i = 0; i < paramstring.length; i++) {
                    paramstring[i] = paramstring[i].replaceAll(" ", "%")
                }

                let qParams = {
                    devicecode: paramstring[0],
                    date: paramstring[1],
                    summaryavail: paramstring[2],
                    trxsuccess: paramstring[3],
                    trxfailed: paramstring[4],
                    merchant: paramstring[5],
                    status: paramstring[6],
                    updateTimestamp: paramstring[7],
                    merchantcode: paramstring[8],
                }

                this.$router.push({ name: "DeviceTransactionSummaryDetails", query: qParams })
            } else {
                console.log("invalid transaction summary detail")
            }
        },
        resetFilter() {
            this.limit = 20
        },
    },
    mounted() {
        this.urlx = url
        try {
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        } catch (e) {
            console.log(e)
        }

        this.gridOptions.getRowStyle = function (params) {
            if (params.node.rowIndex % 2 === 0) {
                return { background: '#f9f9f9' }
            }
        }
        this.gridOptions.rowHeight = 42;

        this.filter.date_begin = moment().format("YYYY-MM-DD")
        this.filter.date_end = moment().format("YYYY-MM-DD")


        Axios.GetUserFromToken(url.svd.auth.me, { authToken: (typeof this.userInfo.access_token.token == 'undefined') ? "" : this.userInfo.access_token.token }).then(response => {
            if (response.data.code == 200) {
                if (response.data.data.role_details.length > 0) {
                    this.userInfo.group = response.data.data.role_details[0].group
                }
            }
            this.showMerchantFilter = this.isShowMerchantFilter()
            this.filter.merchant = this.showMerchantFilter ? "" : this.userInfo.merchant.code

            Axios.Get(url.svd.merchant.combo).then(resp => {
                //this.merchant_list = resp.data

                for (let data of resp.data) {
                    let depth = '- '
                    data.label = depth.repeat(data.depth) + data.full_name
                    if (this.userInfo.merchant.id !== undefined) {
                        if (this.userInfo.merchant.id == data.id || parseInt(data.depth) > parseInt(this.userInfo.merchant.depth)) {
                            if (data.depth < 4) {
                                this.merchant_list.push(data)
                            }
                        }
                    } else {
                        if (data.depth < 4) {
                            this.merchant_list.push(data)
                        }
                    }
                }

                this.merchant_list.unshift({ full_name: "All Merchant", code: "", label: "All Merchant" })
                for (let idx = 0; idx < resp.data.length; idx++) {
                    this.merchants[resp.data[idx].code] = resp.data[idx].full_name
                }
                this.gridApi = this.gridOptions.api;
                this.$root.$on("detail-from-ActionDetailGridComponent", data => {
                    this.detailRecord(data);
                });
                // this.fetchData(1, 20)
                if (this.$route.params.data) {
                    let { page, limit, status, date_begin, date_end, merchant_selected } = this.$route.params.data
                    this.filter.date_begin = date_begin
                    this.filter.date_end = date_end
                    this.filterStatus = status
                    this.selected = merchant_selected
                    this.fetchData(page, limit)
                }
            })
        })

        let merchant = JSON.parse(localStorage.getItem("userInfo")).merchant;

        let merchantidquery = ""

        let merchantid = ((merchant.id !== undefined) ? merchant.id : ((merchant.parent_id !== undefined) ? merchant.parent_id : ""))

        if (merchantid !== "") merchantidquery = "?merchant_id=" + merchantid

        Axios.Get(url.svd.device.listProvisioned + merchantidquery).then(resp => {
            this.device_list = []
            if (typeof resp.data !== 'undefined')
                this.device_list.push({
                    label: "Select All",
                    name: "Select All",
                    text: "Select All",
                    code: "select_all"
                })
            for (let data of resp.data) {
                data.label = data.name + ' - ' + data.code + ' - ' + data.merchant_full_name
                data.device_code = data.code
                this.device_list.push(data)
            }
        })
    }
}
</script>

<style>
.flatpickr-input {
    padding: .7rem;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    color: #626262;
    width: 100%;
}

.vue-simple-suggest.designed .suggestions {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    top: calc(100% + 5px);
    border-radius: 3px;
    border: 1px solid #aaa;
    background-color: #fff;
    opacity: 1;
    z-index: 1000;
    overflow: scroll;
    height: 300px;
}
</style>